import {ROUTES} from "../app.constants";
import {BaseFilterEnum} from "../enums";
import {defaultFilterDisplayTransform} from "../helpers";
import {SettingsConfigInterface} from "../interfaces";

export const SettingsConfig: SettingsConfigInterface = {
  appbarConfig: {
    collapse: false,
    showBack: false,
    title: "Settings",
    subline: "",
    status: "",
    navItems: [
      {
        route: ROUTES.TRUMPF_ORGANISATIONS,
        label: "TRUMPF Organisation Management"
      },
      {
        route: ROUTES.CUSTOMER_MAPPING,
        label: "Customer to Organisation Mapping"
      },
      {
        route: ROUTES.ACCESS_CONTROL,
        label: "Asset Management Access"
      }
    ]
  },
  organisationsList: {
    tableColumns: [
      {
        header: "Shortcode",
        width: "286px",
        field: "shortCode"
      },
      {
        header: "Organisation Name",
        width: "380px",
        field: "name"
      },
      {
        header: "Country",
        width: "272px",
        field: "country"
      },
      {
        header: "Agency",
        width: "323px",
        field: "isAgency",
        transform: (value: unknown) => {
          const bool = value as boolean;
          return bool ? "Yes" : "No";
        }
      },
      {
        header: "Remove",
        width: "166px",
        field: "delete",
        deleteButton: true,
        disableSort: true
      },
      {
        header: "Details",
        width: "110px",
        field: "details",
        hasDetails: true,
        disableSort: true
      }
    ],
    displayFilters: [
      {
        filterName: BaseFilterEnum.Query_Filter,
        transform: defaultFilterDisplayTransform
      }
    ]
  },
  mappingsList: {
    tableColumns: [
      {
        header: "Shortcode",
        width: "286px",
        field: "shortCode"
      },
      {
        header: "Organisation Name",
        width: "380px",
        field: "name"
      },
      {
        header: "Country",
        width: "272px",
        field: "country"
      },
      {
        header: "Number of Customers",
        width: "364px",
        field: "customerOrgCount"
      },
      {
        header: "Details",
        width: "110px",
        field: "details",
        hasDetails: true,
        disableSort: true
      }
    ],
    customerTableColumns: [
      {
        header: "Customer Id",
        width: "262px",
        field: "customerOrgId"
      },
      {
        header: "Customer Name",
        width: "262px",
        field: "name"
      },
      {
        header: "Location",
        width: "262px",
        field: "postalCode"
      },
      {
        header: "Country",
        width: "262px",
        field: "country"
      },
      {
        header: "Number of Assets",
        width: "262px",
        field: "assetCount"
      },
      {
        header: "Remove",
        width: "116px",
        field: "delete",
        deleteButton: true,
        deleteButtonDisabledField: "canNotBeDeleted",
        disableSort: true
      }
    ],
    displayFilters: [
      {
        filterName: BaseFilterEnum.Query_Filter,
        transform: defaultFilterDisplayTransform
      }
    ]
  },
  accessControlList: {
    tableColumns: [
      {
        header: "User ID",
        width: "200px",
        field: "userId"
      },
      {
        header: "Asset Type Access",
        width: "150px",
        field: "assetTypeAccess",
        disableSort: true,
        transform: (value: unknown) => {
          const access = value as Array<{crudRightsText?: string; crudRights?: number}>;
          if (!access || access.length === 0) {
            return "-";
          }

          const processedRights = access
            .map(accessEntry => {
              if (accessEntry.crudRightsText && accessEntry.crudRightsText.trim() !== "") {
                const trimmed = accessEntry.crudRightsText.trim();
                if (trimmed.toLowerCase() === "read") {
return "Read";
}
                if (trimmed.toLowerCase() === "none" || trimmed === "-") {
return "-";
}

                return "Write";
              }

              if (accessEntry.crudRights !== undefined) {
                const rightsValue = Number(accessEntry.crudRights);
                if (rightsValue === 0) {
return "-";
}
                if (rightsValue === 2) {
return "Read";
}
                return "Write";
              }

              return "-";
            })
            .filter(rights => rights !== "-");

          if (processedRights.length === 0) {
return "-";
}
          if (processedRights.includes("Write")) {
return "Write";
}
          if (processedRights.includes("Read")) {
return "Read";
}
          return "-";
        }
      },
      {
        header: "Asset Access (Read Only)",
        width: "300px",
        field: "assetAccessDisplay",
        disableSort: true
      },
      {
        header: "Remove",
        width: "116px",
        field: "delete",
        deleteButton: true,
        disableSort: true
      },
      {
        header: "Details",
        width: "110px",
        field: "details",
        hasDetails: true,
        disableSort: true
      }
    ],
    displayFilters: [
      {
        filterName: BaseFilterEnum.Query_Filter,
        transform: defaultFilterDisplayTransform
      }
    ]
  }
};
